import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";

const Validator = SimpleVueValidation.Validator;


Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            phone: '',
            name: '',
            email: '',
            birth: '',
            job: '',
            introduce: '',
            addr2:'',
            files: [],
            agree:false,

        }
    },
    validators: {
        phone: function (value) {
            return Validator.value(value)
                .required('전화번호를 입력해주세요.')
                .integer('전화번호를 입력해주세요.')
                .minLength(9, '전화번호를 입력해주세요.')
        },
        name: function (value) {
            return Validator.value(value)
                .required("이름을 입력해주세요")
                .regex('^[ㄱ-ㅎ|가-힣|a-z|A-Z|\\*]+$',' 잘못된 형식입니다 <br>(2~5자, 영어, 한글만 가능, 띄어쓰기 불가능)')

        },
        email: function (value) {
            return Validator.value(value)
                .required('이메일을 입력해주세요.')
                .email('이메일 형식이 아닙니다.')
        },
        birth: function (value) {
            return Validator.value(value)
                .required("생년월일을 입력해 주세요")
                .regex('^(19[0-9][0-9]|20\\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$',' 잘못된 형식입니다 <br>숫자만 입력해 주세요')
        },
        job: function (value) {
            return Validator.value(value)
                .required('직업을 입력해주세요.')
        },
        addr2: function (value) {
            return Validator.value(value)
                .required("주소를 선택해 주세요")

        },
        introduce: function (value) {
            return Validator.value(value)
                .required('자기소개를 입력해주세요.')
        },
        files: function (value) {
            return Validator.value(value)
                .required('프로필 사진을 등록해주세요.')

        },
        agree : function (value) {
            return Validator.value(value)
                .custom(() => {
                    if(value === false) {
                        return '약관에 동의해 주세요.'
                    }
                })
        },
    },
    methods: {
    }
}
